import { CheckIcon } from '@components/checkicon';
import Typography from '@components/typography';
import { SHORTLIST } from '@navigation/constants';
import { ModalContent } from 'interface';

export const quoteSaved = () => {
  const buttons = (
    <a
      href={SHORTLIST}
      className="modal-content__body-buttons-button modal-content__body-buttons-button--primary"
      data-testid="quote-saved-go-to-button"
    >
      <Typography
        variant="caption"
        size="rg"
        weight="semi-bold"
        colour="alternative"
      >
        Go to my shortlist
      </Typography>
    </a>
  );

  return {
    icon: <CheckIcon />,
    title: 'Nice choice.',
    message: "We've put the car on your shortlist.",
    buttons: buttons,
  } as ModalContent;
};
